<template>
    <el-button @click="validate"
            :class="['btn_send_sms',{'enable':enableClick}]"
            :disabled="!enableClick" :size="size">{{enableClick ? defaultTitle : countDown + countTitle}}</el-button>
</template>
<script>
export default {
  name: 'ThrottleBtn',
  props: {
    defaultTitle: {
      type: String,
      required: false,
      default: '获取验证码'
    },
    countTitle: {
      type: String,
      required: false,
      default: 's'
    },
    time: {
      type: Number,
      required: false,
      default: 60,
    },
    isValidate: {
      type: Boolean,
      required: false,
      default: false
    },
    size:{
      type: String,
      required: false,
      default: 'mini'
    }
  },
  data () {
    return {
      enableClick: true,
      countDown: 60,
    }
  },
  methods: {
    validate () {
    console.log("this.isValidate",this.isValidate);
      if (this.isValidate) {
        this.$emit('validate')
      } else {
        this.handleClick()
      }
    },
    handleClick () {
      if (!this.enableClick) return
      this.enableClick = false
      let thred = setInterval(() => {
        // --this.countDown
        this.countDown--
        if (this.countDown === 0) {
          clearInterval(thred)
          this.enableClick = true
          this.countDown = this.time
        }
      }, 1000)
      this.$emit('ok')
    }
  },
  watch: {
    time: {
      handler (time) {
        this.countDown = time
        console.log(time);
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.btn_send_sms {
  min-width: 114px;
  height: 44px;
  font-size: 15px;
  font-weight: 400;
  background: #ffffff;
  margin-left: 20px;
}
.enable {
  color:#2676FF ;
  border: 1px solid #2676FF ;
}
</style>